import { FormattedMessage } from '@flipster/i18n';
import { Dialog } from '@flipster/react/design-system/dialog/index';
import { TextButton } from '@flipster/react/design-system/text-button';
import CautionCircleIcon from '@flipster/react/icon/generated/CautionCircleIcon';
import { token } from '@flipster/styled-system/tokens';

interface Props {
  maxInitLeverageRestriction: number | undefined;
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}

/**
 * 자동 레버리지 조정(margin-bonus 정책)으로 주문이 거부됐을 때(AccountMaxInitLeverageRestricted) 안내 다이얼로그.
 * submitOrder가 결과로 신호하면 Actions(UI)에서 연다 — 데이터 레이어는 다이얼로그를 직접 렌더하지 않는다.
 */
export const OrderNotPlacedDialog = ({ maxInitLeverageRestriction, isOpen, onClose, onExit }: Props) => (
  <Dialog.Root isOpen={isOpen} onExit={onExit}>
    <Dialog.Title
      label={<FormattedMessage id='Trade.r251112.Order_not_placed' />}
      leftAddon={<CautionCircleIcon size={24} color={token('colors.content.state.negative')} />}
    />
    <Dialog.Content>
      <FormattedMessage
        id='Autogen_common.r251126.s_Your_order_couldn_t_be_processed_because_your_leverage_was_automatically_adjusted_to_arg0_under_the_bonus_policy'
        values={{ arg0: maxInitLeverageRestriction }}
      />
      <TextButton
        as='a'
        onClick={onClose}
        href='/assets#assets-tabs'
        label={<FormattedMessage id='Common.r250401.Learn_more' />}
        color='passive'
        css={{ mt: 16 }}
      />
    </Dialog.Content>
    <Dialog.Footer>
      <Dialog.Button hierarchy='primary' label={<FormattedMessage id='Common.r250401.Ok' />} onClick={onClose} />
    </Dialog.Footer>
  </Dialog.Root>
);
